import type { ContainerProps } from "@mui/material/Container"
import MUIContainer from "@mui/material/Container"

export default function Container(props: ContainerProps) {
  return (
    <MUIContainer
      {...props}
      maxWidth={"xl"}
      sx={{
        "&.MuiContainer-root": {
          maxWidth: "1920px!important"
        },
        height: "100%",
        pl: 0,
        pr: 0,
        px: 0,
        paddingLeft: 0,
        "padding-left": "0!important",
        "padding-right": "0!important",
        ...props?.sx
      }}
    />
  )
}
